import React, { useState, useEffect } from 'react'
import classNames from 'classnames'

import Checkbox from './Checkbox'
import useWindowWidth from '../../hooks/useWindowHook'

import { breakpoints, spacing, colors } from '../../utils/styles'

const FilterOptionsList = ({
  options,
  products,
  currentFilteringOptions,
  setCurrentFilteringOptions,
  parent,
  ...otherProps
}) => {
  const style = {}

  if (!options[0].hasOwnProperty('options')) {
    const columns = Math.ceil(options.length / 3)
    style.columnCount = `${columns}`
  } else {
    style.display = 'flex'
    // style.columnCount = `${options.length}`
  }

  const appliedTags = currentFilteringOptions.map((filter) => filter.filter)

  return (
    <div className="optionsList" {...otherProps} style={style}>
      {options.map((item) => {
        const hasSubOptions = item.options
        let checked = false
        let disabled = false
        if (!hasSubOptions) {
          const foundOption = currentFilteringOptions.find(
            (el) => item.title === el.title
          )
          checked = foundOption !== undefined

          //disable options based on available products to filter
          disabled =
            products.filter((el) => {
              let matches = false
              matches = el.tags.some(function (el) {
                return item.filter === el
              })

              //short circuit
              if (matches) return matches

              //else go through variants
              const [name, value] = item.filter.split(':')

              for (let i = 0; i < el.variants.length; i++) {
                const variant = el.variants[i]

                let optionsToCheck = variant.selectedOptions.filter(
                  (option) => option.name.toLowerCase() == name
                )
                for (let j = 0; j < optionsToCheck.length; j++) {
                  const option = optionsToCheck[j]

                  const matches =
                    option.name.toLowerCase() == name &&
                    option.value.toLowerCase() == value
                  if (matches) return true
                }
              }
            }).length === 0
        }

        return (
          <>
            {hasSubOptions ? (
              <div className="subFilterList" key={item.title}>
                <h6>{item.title}</h6>
                <div className="filterOptionsList">
                  <FilterOptionsList
                    options={item.options}
                    parent={parent}
                    products={products}
                    currentFilteringOptions={currentFilteringOptions}
                    setCurrentFilteringOptions={setCurrentFilteringOptions}
                  />
                </div>
              </div>
            ) : (
              <Checkbox
                key={item.title}
                title={item.title}
                image={item.image}
                checked={checked}
                disabled={disabled}
                style={{
                  marginBottom: `${spacing.sm}px`,
                }}
                inputProps={{
                  onChange: (event) => {
                    let newArray = [...currentFilteringOptions]

                    if (event.target.checked) {
                      newArray.push({ ...item, type: parent })
                    } else {
                      newArray = currentFilteringOptions.filter(
                        (el) => item.title !== el.title
                      )
                    }

                    setCurrentFilteringOptions(newArray)
                  },
                }}
              />
            )}
          </>
        )
      })}
      <style jsx>{`
        .subFilterList {
        }
        .filterOptionsList {
          margin-top: ${spacing.xs}px;
        }
        .optionsList {
          padding-right: 0;
          min-width: unset;
          width: auto;
          columns: 6 200px;
          margin-top: ${spacing.sm}px;
          margin-bottom: ${-spacing.xs}px;
        }
      `}</style>
    </div>
  )
}

const ProductListingFilter = ({
  filteringOptions = [],
  products = [],
  onFiltersChanged,
}) => {
  const width = useWindowWidth()
  const isDesktop = width >= breakpoints.desktop

  const [currentFilterIndex, setCurrentFilterIndex] = useState(
    isDesktop && filteringOptions.length ? 0 : null
  )
  const [currentFilteringOptions, setCurrentFilteringOptions] = useState([])

  useEffect(() => {
    if (onFiltersChanged) onFiltersChanged(currentFilteringOptions)
  }, [currentFilteringOptions])

  let currentFilter = null
  if (currentFilterIndex !== null) {
    currentFilter = filteringOptions[currentFilterIndex]
  }

  return (
    <div className="productListingFilter sectionContainer">
      <div className="filterHeader">
        <h6 className="title">FILTREAZA DUPA</h6>
        {currentFilteringOptions.length > 0 && (
          <button
            className="clearButton"
            onClick={() => {
              setCurrentFilteringOptions([])
            }}
          >
            Sterge filtrele
          </button>
        )}
      </div>
      <div className="filtersList">
        {filteringOptions.map((item, index) => {
          const selectedFiltersCount = currentFilteringOptions.filter(
            (el) => el.type === item.type
          ).length
          return (
            <div
              className={classNames('filter', {
                currentFilter: index === currentFilterIndex,
              })}
              key={item.title}
              onClick={() => {
                if (index === currentFilterIndex) {
                  setCurrentFilterIndex(null)
                } else {
                  setCurrentFilterIndex(index)
                }
              }}
            >
              <h5 className="filterTitle">
                {item.title}
                {` `}
                {selectedFiltersCount > 0 ? `(${selectedFiltersCount})` : ``}
              </h5>

              <img
                src={
                  index === currentFilterIndex
                    ? '/images/up-black.svg'
                    : '/images/down-black.svg'
                }
                className="filterArrow"
              />
            </div>
          )
        })}
      </div>
      {currentFilter && (
        <div style={{ position: 'relative' }}>
          <div className="filterOptionsList">
            <FilterOptionsList
              options={currentFilter.options}
              parent={currentFilter.type}
              products={products}
              currentFilteringOptions={currentFilteringOptions}
              setCurrentFilteringOptions={setCurrentFilteringOptions}
            />
          </div>
        </div>
      )}
      <style jsx>{`
        .productListingFilter {
          display: flex;
          flex-direction: column;
          margin: 0 auto;
          padding-top: ${spacing.lg}px;
          padding-bottom: ${spacing.lg}px;
          background-color: ${colors.ligherGrey};
        }
        @media (max-width: ${breakpoints.phablet}px) {
          .productListingFilter {
            padding-top: ${spacing.md}px;
            padding-bottom: ${spacing.md}px;
          }
        }

        .filtersList {
          display: flex;
          flex-direction: row;
        }
        .filtersList > :not(:last-child) {
          margin-right: ${spacing.lg}px;
        }
        .filter {
          display: flex;
          flex-direction: row;
          justify-content: center;
          cursor: pointer;
          margin-top: ${spacing.sm}px;
        }
        .filterArrow {
          margin-left: ${spacing.sm}px;
        }
        .filterOptionsList {
          margin-top: ${2 * spacing.sm}px;
          display: flex;
        }
        .filterOptionsList::before {
          position: absolute;
          content: '';
          top: ${spacing.sm}px;
          background-color: #d3d3d3;
          height: 1px;
          width: 100%;
        }
        .currentFilter {
          color: ${colors.brand};
        }
        .filterHeader {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .clearButton {
          background-color: transparent;
          background-repeat: no-repeat;
          border: none;
          cursor: pointer;
          overflow: hidden;
          outline: none;
          color: ${colors.brand};
          padding: 0;
          border-bottom: 1px solid transparent;
        }
        .clearButton:hover {
          border-bottom: 1px solid ${colors.brand};
        }
      `}</style>
    </div>
  )
}

export default ProductListingFilter
